<template>
    <div class="px-5 py-2 md:px-10 md:py-20">
        <div class="flex items-center justify-center h-full">
            <div class="w-full md:w-3/4 xl:w-1/2">
                <div class="hidden md:block mb-5">
                    <div class="flex justify-between">
                        <h1 class="font-hairline lowercase">{{ $t('whatsapp_accounts') }}</h1>

                        <button class="btn text-right w-1/2"
                                @click="$router.push('/clients/qr-code-scan')">
                            <icon icon="plus"></icon> {{ $t('add_new_whatsapp') }}
                        </button>
                    </div>
                </div>

                <div v-if="!loading">
                    <div class="grid w-full grid-cols-1" >
                        <div v-for="(instance, k) in instances"
                             class="bg-white text-gray-700 rounded flex justify-between chat" :key="k">
                            <div class="flex items-center p-4 my-2"
                                 @click="view(instance)">

                                <div class="w-auto">
                                    <img @error="imageError(instance)" class="w-10 h-10 rounded-full mr-8 md:mr-5" :src="instance.image">
                                </div>

                                <div class="text-sm w-4/5">
                                    <p class="text-gray-900 font-bold leading-none">{{ instance.name }}</p>

                                    <div class="mt-1 text-gray-600">
                                        <p v-if="instance.last_sync">
                                            {{ $t('last_sync') }} {{ $filters.dt(instance.last_sync, 'fromNow') }}
                                        </p>

                                        <p v-else-if="!instance.schedules_count" class="text-gray-400 text-xs">
                                            {{ $t('to_synchronize_latest_information_create_schedules') }}
                                        </p>

                                        <p v-else class="text-gray-400 text-xs">
                                            {{ $t('schedules_count', [instance.schedules_count]) }}
                                        </p>
                                    </div>

                                    <div class="mt-2" v-if="instance.alerts">
                                        <div class="mb-2" v-for="(a, k) in instance.alerts" :key="k">
                                            <div class="p-1 px-2 rounded text-white"
                                                  :class="{
                                                    'bg-red-600': a.type === 'danger',
                                                    'bg-yellow-600': a.type === 'warning',
                                                    'bg-blue-600': a.type === 'info'
                                                   }">
                                                {{ a.message }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="text-right w-1/5">
                                <button class="bg-red-600 text-white p-2 h-full rounded-r" @click="remove(instance)">
                                    {{ $t('delete') }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div v-if="loading" class="flex items-center justify-center p-20">
                    <div class="loader"></div>
                </div>

                <div v-if="!instances.length && !loading" class="text-center pt-24">
                    <h1 class="text-white opacity-25">
                        {{ $t('no_accounts_added') }}
                    </h1>
                </div>
            </div>
        </div>
    </div>
</template>

<style>
    .chat {
        cursor: pointer;
        transition: all 0.3s;
    }

</style>

<script>
    import { Zapin } from "@/services/Api";

    export default {

        data() {
            return {
                loading: true,
                instances: []
            }
        },


        mounted() {
            this.loadInstances();

            this.$emit('set-action-bar', {
                title: this.$t('accounts'),
                buttons: [
                    {
                        icon: 'plus',
                        link: '/clients/qr-code-scan'
                    },
                    {
                        icon: 'sync',
                        cb: () => {
                            this.loadInstances();
                        }
                    }
                ]
            });
        },

        methods: {
            remove(instance) {
                return this.$router.push({
                    name: 'DeleteInstance',
                    params: {
                        id: instance.token
                    }
                })
            },

            loadInstances() {
                this.loading = true;

                Zapin
                    .instances()
                    .all()
                    .then(res => {
                        this.instances = res.data;
                    })
                    .finally(() => this.loading = false);
            },

            isWapi(instance) {
                return instance.configs && instance.configs.wapi;
            },

            async view(instance) {
                if (this.isWapi(instance)) {
                    return this.$router.push({
                        name: 'InstanceWapi',
                        params: {
                            id: instance.token
                        }
                    })
                }

                this.$router.push({
                    name: 'InstanceChats',
                    params: {
                        id: instance.token
                    }
                });
            },

            imageError(instance) {
                instance.image = '/images/unknown.jpg';
            }

        }

    }
</script>
